<style scoped>
.validValueCss {
  display: inline-block;
  font-family: SimSun;
  font-size: 12px;
  color: #ed3f14;
  position: relative;
  top:0px;
  left: 5px;
}
</style>
<template>
  <div>
      <!--返回列表按钮-->
      <div style="margin:0 0 10px 10px;">
        <Icon type="chevron-left"></Icon>
        <a @click='backPage'>{{ $t('common.backToList') }}</a>
      </div>
      <div style="background-color: #fff;margin:0 10px 0 10px;padding:10px 0 0 10px;">
        <Form ref="pageParams" :model="pageParams" :label-width="180" label-position="right" :rules="ruleValidate">
            <span style="color:#ed3f14;font-size:10px;">({{$t('logisticsProvider.remark')}})</span>
            <h2>{{$t('logisticsProvider.baseInformation')}}</h2>
            <div style="padding-left:20px;padding-top:10px;">
              <Row>
                <!-- 仓库名称 -->
                <Col span="10">
                  <Form-item :label="$t('logisticsProvider.warehouseName') + '：'" prop="warehouseName">
                    <Input v-model.trim="pageParams.warehouseName"></Input></br>
                    <span style="color:red">仓库名称需要体现当前海外仓的名称、方便客户很快搜索，例如：万邑通海外仓-美国仓</span>
                  </Form-item>
                </Col>
                <!-- 仓库代码 -->
                <Col span="10" push="2">
                  <Form-item :label="$t('logisticsProvider.warehouseCode') + '：'" prop="warehouseCode">
                    <Input v-model.trim="pageParams.warehouseCode"></Input>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <!-- 仓库所在国家 -->
                <Col span="10">
                  <Form-item :label="$t('logisticsProvider.country') + '：'">
                    <Select v-model="pageParams.countryCode">
                      <Option v-for="(item, index) in countryList" :key="index" :value='item.twoCode'>{{item.cnName}}</Option>
                    </Select>
                  </Form-item>
                </Col>

              </Row>
          </div>
          <div class="cutline"></div>
        </Form>
        <div class='fr' style="margin:20px 0;">
          <Button @click="cancel" style="margin-right:10px;" icon="close-round">{{$t('common.cancel')}}</Button>
          <Button type="primary" @click="saveBtn" :loading="loading2" icon="checkmark-round">{{$t('common.save')}}</Button>
        </div>
      </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  props: ['tmpwarehouseId', 'addFlag'],
  mixins: [ Mixin, tableMixin ],
  components: {

  },
  data () {
    let self = this;
    return {
      file: null,
      uploadHeader: {
        'Authorization': sessionStorage.getItem('token')
      },
      delModal: false, // 删除模态框
      loading2: false,
      pageParams: {
        warehouseName: '', // 仓库名称
        warehouseCode: '', // 仓库代码
        countryCode: ''// 仓库所在国家
      },
      // 校验
      ruleValidate: {
        warehouseName: [
          { required: true, message: self.t('validValue.nowarehosueName'), trigger: 'blur' }
        ],
        warehouseCode: [
          { required: true, message: self.t('validValue.nowarehouseCode'), trigger: 'blur' }
        ]
      },
      delIndex: null, // 删除行的下标
      countryList: [],
      currCountry: ''
    };
  },
  methods: {
    // 返回列表
    backPage () {
      this.$parent.workShow = 'list';
    },
    cancel () {
      let v = this;
      if (v.addFlag === 'add') {
        v.$parent.workShow = 'list'; // 关闭模态框
        v.clearFormData();
      } else {
        v.$parent.workShow = 'list'; // 关闭模态框
      }
    },
    // 保存渠道信息校验
    saveValidFn () {
      let v = this;
      let valid = true;
      // var reg = /^\d+$/;
      // 渠道名称
      if (v.pageParams.warehosueName === '') {
        v.$Message.info({
          content: v.t('validValue.nowarehouseName'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 渠道代码
      let value = v.pageParams.warehouseCode;
      if (value === '') {
        v.$Message.info({
          content: v.t('validValue.nowarehosueCode'),
          duration: 3
        });
        valid = false;
        return;
      }
      return valid;
    },

    // 查询仓库详情
    getwarehouseDtlInfo () {
      let v = this;
      v.axios.post(api.warehouse_getDetail + '?warehouseId=' + v.tmpwarehouseId)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            v.pageParams.warehouseName = data.warehouseName; // 仓库名称
            v.pageParams.warehouseCode = data.warehouseCode; // 仓库代码
            v.currCountry = data.countryCode;
            v.getCountryList();
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 保存仓库
    saveBtn () {
      let v = this;
      v.loading2 = true; // 保存加载
      let isSupportSmartRouting = null;// 是否支持智能路由(0:不支持 1：支持)
      let isSupportSecondaryForecast = null;// 是否支持二次预报业务(0:不支持 1：支持)
      let secondaryForecastType = null;// 二次预报类型（0:全部；1:绑定第三方物流渠道；2:自有渠道绑定第三方物流渠道）
      if (!v.tmpwarehouseId || v.tmpwarehouseId === '') {
        isSupportSmartRouting = '0';
        isSupportSecondaryForecast = '0';
        secondaryForecastType = '0';
      }
      // 组装参数
      let objParams = {
        warehouseId: v.tmpwarehouseId, // 仓库ID
        warehouseName: v.pageParams.warehouseName, // 仓库名称
        warehouseCode: v.pageParams.warehouseCode, // 仓库代码
        countryCode: v.pageParams.countryCode,
        isSupportSmartRouting: isSupportSmartRouting,
        isSupportSecondaryForecast: isSupportSecondaryForecast,
        secondaryForecastType: secondaryForecastType
      };
      if (v.saveValidFn()) {
        v.axios.post(api.warehouse_save, objParams)
          .then(res => {
            if (res.data.code === 0) {
              v.loading2 = false; // 保存加载
              v.$Message.success(v.t('common.saveSuccess'));
              v.$parent.workShow = 'list'; // 新增成功之后，关闭模态框
              v.clearFormData();
              v.$parent.pageParamsStatus = true; // 保存成功之后，触发表格刷新
            } else {
              v.loading2 = false; // 保存加载
              v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
            }
          });
      } else {
        v.loading2 = false; // 保存加载
      }
    },

    // 清空表单数据
    clearFormData () {
      let v = this;
      v.pageParams.warehosueName = ''; // 仓库名称
      v.pageParams.warehouseCode = ''; // 仓库代码
      v.pageParams.countryCode = '';
    },
    // 获取国家列表
    getCountryList () {
      let v = this;
      let pos = [];
      v.axios.get(api.get_countrys)
        .then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            data.forEach((n, i) => {
              pos.push({
                cnName: n.cnName,
                twoCode: n.twoCode
              });
            });
            v.countryList = pos;
            v.pageParams.countryCode = v.currCountry;
          } else {
            v.showErrorInfoFn(response.data.code, response.data.message); // 错误提示方法
          }
        });
    }
  },
  created () {
    let v = this;
    if (v.tmpwarehouseId) {
      v.getwarehouseDtlInfo(); // 查询仓库信息
    } else {
      v.getCountryList();
    }
  },
  watch: {
    addFlag: function (val) {
      if (val === 'add') {
        this.clearFormData();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/warehouseDetail.vue